import { alpha, darken, lighten, Theme } from "@mui/material";

export const getButtonOverrides = (theme: Theme) => {
  const isDark = theme.palette.mode === "dark";
  // Fonte única: primary.dark já é o cobalt-glow calibrado por modo
  // (theme/palette/{light,dark}.ts). Mudar lá muda botão, título, breadcrumb
  // e menu juntos, sem duplicar o cálculo aqui.
  const accent = theme.palette.primary.dark;
  const accentHover = isDark ? lighten(accent, 0.15) : darken(accent, 0.15);
  const accentText = "#ffffff";

  return {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          borderRadius: 8,
          textTransform: "none",
          padding: "6px 16px",
          color: accentText,
          backgroundColor: accent,
          "&:hover": {
            border: "1px solid white",
          },
        },
        containedPrimary: {
          backgroundColor: accent,
          color: accentText,
          "&:hover": {
            backgroundColor: accentHover,
          },
          "&:disabled": {
            backgroundColor: "#bdbdbd",
            color: "#eeeeee",
          },
        },
        containedError: {
          backgroundColor: theme.palette.error.main,
          color: theme.palette.error.contrastText,
          "&:hover": {
            backgroundColor: theme.palette.error.dark,
          },
        },
        containedSuccess: {
          backgroundColor: theme.palette.success.main,
          color: theme.palette.success.contrastText,
          "&:hover": {
            backgroundColor: theme.palette.success.dark,
          },
        },
        containedWarning: {
          backgroundColor: theme.palette.warning.main,
          color: theme.palette.warning.contrastText,
          "&:hover": {
            backgroundColor: theme.palette.warning.dark,
          },
        },
        outlinedPrimary: {
          border: `1px solid ${accentHover} !important`,
          color: "#FFFFFF !important",
          "&:hover": {
            backgroundColor: alpha(accent, 0.66),
            borderColor: accent,
          },
          "& .MuiSvgIcon-root": {
            color: "#FFFFFF",
            marginRight: 8,
          },
        },
        outlinedError: {
          border: `1px solid ${theme.palette.error.main} !important`,
          color: `${theme.palette.error.main} !important`,
          backgroundColor: "transparent !important",
          "&:hover": {
            backgroundColor: alpha(theme.palette.error.main, 0.08),
          },
        },
        fullWidth: {
          width: "100%",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: isDark ? "#FFFFFF" : accent,
          "&:hover": {
            backgroundColor: isDark ? "rgba(255, 255, 255, 0.08)" : undefined,
          },
        },
      },
    },
  };
};
